import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import styles from './ImageModal.module.css';

const ImageModal = ({ isOpen, onClose, imageSrc, alt }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEscape);
    }
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <button
        className={styles.closeButton}
        onClick={onClose}
        aria-label="Close modal"
      >
        <X size={24} />
      </button>
      <div className={styles.content} onClick={(e) => e.stopPropagation()}>
        <img src={imageSrc} alt={alt || "Enlarged view"} className={styles.image} />
      </div>
    </div>
  );
};

export default ImageModal;
